import { ComponentContentTypes } from '@constants/enums/content-types'

import { VideoAsset } from '@components/asset/video/video'
import { AssetImage } from '@components/contentful-content-types/asset-image/asset-image'

import { buildContentRenderer } from '../generic'

const contentTypeMap = {
  [ComponentContentTypes.AssetImage]: AssetImage,
  [ComponentContentTypes.AssetVideo]: VideoAsset,
} as const

export const AssetRenderer = buildContentRenderer(contentTypeMap)
